export const categories = [
  { id: 1, name: "Electronics" },
  { id: 2, name: "Fashion" },
  { id: 3, name: "Footwear" },
  { id: 4, name: "Home & Furniture" },
  { id: 5, name: "Beauty & Personal Care" },
  { id: 6, name: "Groceries & Food" },
  { id: 7, name: "Books" },
  { id: 8, name: "Sports & Fitness" },
  { id: 9, name: "Toys & Games" },
  { id: 10, name: "Automotive" },
  { id: 11, name: "Mobile Phones" },
  { id: 12, name: "Laptops & Computers" },
  { id: 13, name: "Watches" },
  { id: 14, name: "Jewelry" },
  { id: 15, name: "Health & Wellness" },
  { id: 16, name: "Pet Supplies" },
  { id: 17, name: "Office Supplies" },
  { id: 18, name: "Baby Products" },
  { id: 19, name: "Kitchen & Dining" },
  { id: 20, name: "Others" }
];


  export const mockProducts = [
    {
      id: 4,
      title: "Classic Grey Hooded Sweatshirt",
      slug: "classic-grey-hooded-sweatshirt",
      price: 90,
      description:
        "Elevate your casual wear with our Classic Grey Hooded Sweatshirt...",
      category: {
        id: 1,
        name: "Clothes",
        slug: "clothes",
        image: "https://i.imgur.com/QkIa5tT.jpeg",
      },
      images: [
        "https://i.imgur.com/R2PN9Wq.jpeg",
        "https://i.imgur.com/IvxMPFr.jpeg",
        "https://i.imgur.com/7eW9nXP.jpeg",
      ],
      stock: 150,
      sku: "PROD001",
      discountPercentage: 10,
      rating: 4.5,
      creationAt: "2025-12-21T10:10:21.000Z",
      updatedAt: "2025-12-21T10:10:21.000Z",
    },
    {
      id: 5,
      title: "Wireless Bluetooth Headphones",
      slug: "wireless-bluetooth-headphones",
      price: 199,
      description: "Premium wireless headphones with noise cancellation...",
      category: {
        id: 2,
        name: "Electronics",
        slug: "electronics",
      },
      images: ["https://i.imgur.com/xyz123.jpeg"],
      stock: 75,
      sku: "PROD002",
      discountPercentage: 15,
      rating: 4.8,
      creationAt: "2025-12-21T10:10:21.000Z",
      updatedAt: "2025-12-21T10:10:21.000Z",
    },
  ];